var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61242 0H8.63041L13.7309 5.31635V15.6567C13.7309 16.952 12.6829 18 11.392 18H2.61242C1.31708 18 0.269104 16.952 0.269104 15.6567V2.34332C0.269081 1.04797 1.31705 0 2.61242 0Z",
    fill: "#E5252A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62592 0V5.27586H13.7309L8.62592 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87329 13.4304V10.1426H4.2721C4.61843 10.1426 4.8928 10.237 5.09969 10.4304C5.30658 10.6193 5.41004 10.8757 5.41004 11.1951C5.41004 11.5144 5.30658 11.7708 5.09969 11.9597C4.8928 12.1531 4.61843 12.2475 4.2721 12.2475H3.71437V13.4304H2.87329ZM3.71437 11.5324H4.17764C4.30357 11.5324 4.40253 11.5054 4.47001 11.4425C4.53746 11.384 4.57346 11.303 4.57346 11.1951C4.57346 11.0871 4.53748 11.0062 4.47001 10.9477C4.40255 10.8847 4.3036 10.8578 4.17764 10.8578H3.71437V11.5324ZM5.75635 13.4304V10.1426H6.92126C7.15065 10.1426 7.36655 10.1741 7.56894 10.2415C7.77133 10.309 7.95575 10.4035 8.11766 10.5339C8.27959 10.6598 8.41002 10.8307 8.50447 11.0466C8.59442 11.2625 8.64391 11.5099 8.64391 11.7888C8.64391 12.0631 8.59444 12.3105 8.50447 12.5264C8.41002 12.7423 8.27959 12.9132 8.11766 13.0391C7.95573 13.1696 7.77133 13.264 7.56894 13.3315C7.36655 13.3989 7.15065 13.4304 6.92126 13.4304H5.75635ZM6.57944 12.7153H6.82231C6.95274 12.7153 7.07419 12.7018 7.18663 12.6703C7.29457 12.6388 7.39802 12.5894 7.49698 12.5219C7.59143 12.4544 7.66789 12.36 7.72186 12.234C7.77583 12.1081 7.80283 11.9597 7.80283 11.7888C7.80283 11.6133 7.77583 11.4649 7.72186 11.339C7.66789 11.2131 7.59143 11.1186 7.49698 11.0511C7.39802 10.9837 7.29459 10.9342 7.18663 10.9027C7.07419 10.8712 6.95274 10.8577 6.82231 10.8577H6.57944V12.7153ZM9.0667 13.4304V10.1426H11.4055V10.8577H9.90778V11.384H11.1042V12.0946H9.90778V13.4304H9.0667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfFile);
export default __webpack_public_path__ + "static/media/IconPdfFile.0a0b2be58374573068bb5c0f26e5e7ec.svg";
export { ForwardRef as ReactComponent };